"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsTransfer_1 = require("../../model/hsTransfer");
var service_1 = require("../../../library/base/service");
var ProductDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ProductDetail, _super);
    function ProductDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '转让产品详情页接口';
        _this.code = '105011';
        _this.desc = '转让产品详情页接口';
        _this.requestParams = new hsTransfer_1.ProductDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ProductDetail;
}(service_1.BaseService));
exports.ProductDetail = ProductDetail;
//# sourceMappingURL=productDetail.js.map